import React from 'react';
import { FormControl, FormLabel } from '@mui/material';
import { AdminUserPicker } from '../../shared/pickers/AdminUserPicker';
import { AdminBrokerGroupPicker } from '../../shared/pickers/AdminBrokerGroupPicker';
import { AdminLedgerPicker } from '../../shared/pickers/AdminLedgerPicker';

const FILTERS = [
	{ field: 'users', label: 'User', Picker: AdminUserPicker },
	{ field: 'brokerGroups', label: 'Broker group', Picker: AdminBrokerGroupPicker },
	{ field: 'ledgers', label: 'Ledger', Picker: AdminLedgerPicker },
];

/**
 * The feature flags table's filters, one element per filter for AdminListToolbar: flags
 * that directly target the chosen users, broker groups or ledgers (see useFeatureFlagFilter).
 * Each has "All" and "Clear Filter" options. Values are saved in the admin table prefs
 * through useAdminListParams' filters / setFilter.
 */
export const getFeatureFlagFilters = ({ filters, setFilter }) =>
	FILTERS.map(({ field, label, Picker }) => (
		<FormControl key={field} fullWidth>
			<FormLabel>{label}</FormLabel>
			<Picker
				value={filters[field] ?? []}
				onChange={(ids) => setFilter(field, ids.length ? ids : undefined)}
				showCheckbox
				showAllOption
				showClearOption
			/>
		</FormControl>
	));
